/**
 * Helper utilities for dynamic current date, time, and year
 */

export const getCurrentDateString = (offsetDays = 0): string => {
  const now = new Date();
  if (offsetDays !== 0) {
    now.setDate(now.getDate() + offsetDays);
  }
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getCurrentTimeString = (offsetHours = 1): string => {
  const now = new Date();
  now.setHours(now.getHours() + offsetHours);
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = '00';
  return `${hours}:${minutes}`;
};

export const formatReadableDate = (dateStr: string): string => {
  if (!dateStr) return getCurrentDateString();
  try {
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      const year = parts[0];
      const monthIndex = parseInt(parts[1], 10) - 1;
      const day = parts[2];
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return `${day} ${monthNames[monthIndex] || ''} ${year}`;
    }
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return dateStr;
  }
};

export const getCurrentYear = (): number => {
  return new Date().getFullYear();
};
